// waitbox.js
// A tiny utility for showing/hiding a consistent "please wait" modal.

const WaitBox = (() => {
  let box = null;

  // Default spinner/message (Bootstrap 4/5)
  const defaultMessage = "Processing your request, please wait ...";
  const spinnerHTML = `
    <div class="text-center py-3">
      <div class="text-center py-2">
         <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
         <div class="mt-3" data-wb-message></div>
       </div>
    </div>`;

  function ensureBox(options = {}) {
    const { message = defaultMessage, backdrop = true, closeButton = false, onEscape = false } = options;

    if (box) return update({ message }); // already open → just update message

    box = bootbox.dialog({
      message: spinnerHTML,
      backdrop,
      closeButton,
      onEscape
    });

    // Inject initial text
    box.on('shown.bs.modal', () => {
      const el = box.find('[data-wb-message]');
      if (el.length) el.text(message);
    });

    // Clean up reference on hide
    box.on('hidden.bs.modal', () => { box = null; });
    return box;
  }

  function update({ message }) {
    if (!box) return null;
    if (message != null) {
      const el = box.find('[data-wb-message]');
      if (el.length) el.text(message);
    }
    return box;
  }

  function show(options = {}) {
    return ensureBox(options);
  }

  function hide() {
    if (box) box.modal('hide');
    box = null;
  }

  return { show, hide, update };
})();

export default WaitBox;
